module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_serif-italic-web.eot?7eccf7f67a3e5b01c67923b06705a5fa";